// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetWidgetHostConfigAsyncRequestViewModel from '../../viewModel/request/WidgetHostConfigs/GetWidgetHostConfigAsyncRequestViewModel';
import WidgetHostConfigResourcePagingResultViewModel from '../../viewModel/resource/WidgetHostConfigResourcePagingResultViewModel';
import WidgetHostConfigRequestViewModel from '../../viewModel/resource/WidgetHostConfigRequestViewModel';
import WidgetHostConfigResourceViewModel from '../../viewModel/resource/WidgetHostConfigResourceViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getWidgetHostConfigAsync(request: GetWidgetHostConfigAsyncRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-host-config-async'] ?? 'core/WidgetHostConfigs';
    const response = await service.get<any>(endpointPath, {
      query: {
        isDebug: requestDTO.isDebug,
        isActive: requestDTO.isActive,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new WidgetHostConfigResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async createWidgetHostConfig(model: WidgetHostConfigRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-create-widget-host-config'] ?? 'core/WidgetHostConfigs';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
  },
  /**  */
  async getWidgetHostConfigByIdAsync(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-host-config-by-id-async'] ?? 'core/WidgetHostConfigs/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new WidgetHostConfigResourceViewModel().fromDTO(dto);
  },
  /**  */
  async updateWidgetHostConfig(id: number, model: WidgetHostConfigRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-widget-host-config'] ?? 'core/WidgetHostConfigs/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.put<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
  },
  /**  */
  async deleteWidgetHostConfig(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-delete-widget-host-config'] ?? 'core/WidgetHostConfigs/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.delete<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
});
